import { TherapistResponse } from '../types/types';

export const getGeminiResponse = async (userInput: string): Promise<TherapistResponse> => {
  try {
    const response = await fetch('/api/gemini', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userInput }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.error || `Request failed with status ${response.status}`);
    }

    const data: TherapistResponse = await response.json();

    // Check for error responses from the AI (e.g. unrecognized input)
    if ((data as any).error) {
      throw new Error((data as any).error);
    }

    return data;
  } catch (error) {
    console.error('Error getting response:', error);
    throw error;
  }
};